<template>
    <article class="career-listing">
        <a :href="careerPost.link">
            <div class="row">

                <div class="col-6 col-md-4">
                <div class="listing-meta">
                    <span class="listing-brand">{{ careerPost.career_hotel.post_title }}</span>
                    <div class="listing-city">{{ careerPost.career_location }}</div>
                </div>
                </div>

                <div class="col-6 col-md-7 offset-md-1">
                <h3 class="bold-heading small blue-lighter-text" v-html="careerPost.title.rendered"></h3>
                </div>

            </div>
        </a>
    </article>
</template>

<script>
export default {
  name: 'CareerItem',
  props: {
    careerPost: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/career-item.vue